import { render, staticRenderFns } from "./w-switch.vue?vue&type=template&id=1ab9d369&"
import script from "./w-switch.vue?vue&type=script&lang=ts&"
export * from "./w-switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports